/** Font family names from @expo-google-fonts (loaded in hooks/useCustomFonts.js) */
export const fontFamily = {
  abhaya: "AbhayaLibre_400Regular",
  abhayaBold: "AbhayaLibre_700Bold",
  arvo: "Arvo_400Regular",
  arvoBold: "Arvo_700Bold",
};
